// Basada en el adapter original de https://github.com/jeffreyguenther/vue-turbolinks
// No podemos usar el original porque la versión de turbolinks classic que espera
// es mas avanzada que la nuestra y los eventos son distintos

function defaultEvent() {
  if (typeof Turbo !== 'undefined') {
    return 'turbo:visit';
  }

  // El vento por defecto para la versión de turbolinks que usamos en Cifra
  // es distinto, es page:load
  // return 'turbolinks:visit';
  return 'page:load';
}

function handleVueDestruction(vue) {
  const event = vue.$options.destroyEvent || defaultEvent();

  document.addEventListener(event, function teardown() {
    vue.$destroy();
    document.removeEventListener(event, teardown);
  });
}

const Mixin = {
  beforeMount() {
    // If this is the root component, we want to cache the original element
    // contents to replace later
    // We don't care about sub-components, just the root
    if (this === this.$root && this.$el) {
      handleVueDestruction(this);

      // cache original element
      this.$cachedHTML = this.$el.outerHTML;

      // register root hook to restore original element on destroy
      this.$once('hook:destroyed', () => {
        if (this.$el.parentNode) {
          this.$el.outerHTML = this.$cachedHTML;
        }
      });
    }
  },
};

function plugin(Vue, _options) {
  // Install a global mixin
  Vue.mixin(Mixin);
}

export { Mixin as turbolinksAdapterMixin };
export default plugin;
